<template>
    <div>
        <div class="d-flex justify-content-end my-2">
            <b-button
                    v-b-modal.createMaterialTarget
                    size="sm"
                    variant="success"
                    v-if="!archiveOnly && $can('create', 'materialTargets')"
            >
                Добавить объем материалов по договору
            </b-button>
        </div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-select
                                v-model="archiveOnly"
                                :options="archiveScopeOptions"
                                aria-label="Статус объекта"
                        ></b-form-select>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="tableFields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :busy="isBusy"
                sticky-header="80vh"
        >
            <template v-slot:cell(actions)="data">
                <i class="fas fa-pen text-center text-success mx-2"
                   @click="onEdit(data.item)"
                   v-if="!archiveOnly && $can('update', 'materialTargets')"
                ></i>
                <i class="fas fa-trash-alt text-danger text-center mx-2"
                   @click="onDelete(data.item)"
                   v-if="!archiveOnly && $can('delete', 'materialTargets')"
                ></i>
            </template>
        </b-table>
        <delete-material-target></delete-material-target>
        <edit-material-target></edit-material-target>
    </div>
</template>

<script>
    import DeleteMaterialTarget from "./DeleteTarget/DeleteMaterialTarget.vue";
    import EditMaterialTarget from "./EditTarget/EditMaterialTarget.vue";
    export default {
        components: {
            DeleteMaterialTarget,
            EditMaterialTarget
        },
        computed: {
            items() {
                return this.$store.state.materials.targets;
            },
            tableFields() {
                return this.archiveOnly
                    ? this.fields.filter(field => field.key !== `actions`)
                    : this.fields;
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: `object_name`,
                        label: `Имя объекта`,
                        sortable: true
                    },
                    {
                        key: `target_work_name`,
                        label: `Работа`,
                        sortable: true
                    },
                    {
                        key: `target_work_measures`,
                        label: `ЕИ`
                    },
                    {
                        key: `target_work_value`,
                        label: `Объем`
                    },
                    {
                        key: `material_name`,
                        label: `Имя материала`,
                        sortable: true
                    },
                    {
                        key: `measures`,
                        label: `ЕИ`
                    },
                    {
                        key: `value`,
                        label: `Количество материала на весь объём работы`,
                        sortable: true
                    },
                    {
                        key: `limit`,
                        label: `Граница срабатывания тревоги, %`,
                        sortable: true
                    },
                    {
                        label: ``,
                        key: `actions`,
                        class: `w-80px`
                    }
                ],
                filter: null,
                filterOn: [],
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                archiveOnly: false,
                archiveScopeOptions: [
                    {value: false, text: `Действующие объекты`},
                    {value: true, text: `Архив объектов`}
                ],
                isBusy: true,
                value: null
            }
        },
        async mounted() {
            await this.loadMaterialTargets();
        },
        methods: {
            async loadMaterialTargets() {
                this.isBusy = true;
                try {
                    await this.$store.dispatch(`getMaterialTargets`, this.archiveOnly);
                    await this.$nextTick();
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                } finally {
                    this.isBusy = false;
                }
            },
            onDelete({id}) {
                this.$store.commit(`setSelectedMaterialTargetId`, id);
                this.$bvModal.show(`deleteMaterialTarget`);
            },
            onEdit({id}) {
                this.$store.commit(`setSelectedMaterialTargetId`, id);
                this.$bvModal.show(`editMaterialTarget`);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            }
        },
        watch: {
            archiveOnly() {
                this.loadMaterialTargets();
            }
        },
        name: "MaterialTargets"
    }
</script>

<style scoped>

</style>
